export type WorkflowAlert = {
  id: string;
  timestamp: string;
  camera_id: string;
  node_id: string;
  type: string;
  severity: string;
  detail: string;
  snapshot?: string;
  acknowledged: boolean;
};

export async function getWorkflowAlerts(): Promise<WorkflowAlert[]> {
  const response = await fetch('/api/workflow/alerts');
  if (!response.ok) throw new Error('Load workflow alerts failed');
  return response.json() as Promise<WorkflowAlert[]>;
}

export async function acknowledgeWorkflowAlert(id: string): Promise<void> {
  const response = await fetch(`/api/workflow/alerts/${encodeURIComponent(id)}/acknowledge`, { method: 'POST' });
  if (!response.ok) throw new Error('Acknowledge workflow alert failed');
}
